import { Checkbox, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutPortalSqlDDef extends Layout {
    chkbFormatSql: Checkbox;
    pnlsqlstmt: Panel;
    sourceRenlgxsqld2: DataSource;
    sourceRenlgxsqld: DataSource;
    textboxLgxsdMultirows: Textbox;
    textboxLgxsdSqlgid: Textbox;
    textboxLgxsdSqlseq: Textbox;
    textboxLgxsdSqlstmt: Textbox;
    textboxLgxsdStmtdesc: Textbox;
}
